import { Flex, Label, PopOver, Span, styled, Link } from '@fareye/ui'
import { FaChevronRight } from '@fareye/utils'

import React from 'react'

export const LabelData: any = styled(Label)`
  textalign: center;
  fontsize: 16px;
  borderradius: 5px;
  padding: 5px;
  margin: 5px;
  display: block;
`
const FoundList = ({ notFoundList, foundCount }: any) => {
  return (
    <Flex style={{ margin: '3px' }}>
      <LabelData style={{ color: '#14bc6d', backgroundColor: '#ddffed' }}>
        {notFoundList.length === 0 && <span>All Reference IDs found</span>}
        {notFoundList.length !== 0 && (
          <span>{foundCount} Reference IDs found</span>
        )}
      </LabelData>

      {notFoundList.length !== 0 && (
        <PopOver variant="arrow">
          <LabelData style={{ color: '#e73753', backgroundColor: '#ffe2e7' }}>
            {notFoundList.length} Reference IDs not found &nbsp;{' '}
            <FaChevronRight size={12} />
          </LabelData>

          <PopOver.Body
            variant="Right-Top"
            style={{ maxHeight: '175px', width: 'auto', overflow: 'auto' }}
          >
            {notFoundList.map((item: any, n: any) => (
              <Flex p={2} key={n} style={{ textAlign: 'center' }}>
                <Label variant="ellipsis">{item}</Label>
              </Flex>
            ))}
          </PopOver.Body>
        </PopOver>
      )}
    </Flex>
  )
}

export default FoundList
